import React from 'react';
import { Thermometer, Wind } from 'lucide-react';

const WeatherWidget = ({ data }) => (
  <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100">
    <div className="flex items-center gap-2 mb-4">
      <Thermometer className="h-5 w-5 text-blue-600" />
      <h3 className="text-lg font-semibold text-gray-900">Environmental Conditions</h3>
    </div>
    <div className="space-y-4">
      {data.map((day, index) => (
        <div key={index} className="flex justify-between items-center">
          <span className="text-gray-600">{day.date}</span>
          <div className="flex items-center gap-4">
            <span className="text-blue-600">{day.min}°F</span>
            <span>-</span>
            <span className="text-red-600">{day.max}°F</span>
            <span className="text-gray-500 flex items-center gap-1">
              <Wind size={14} />
              {day.precip}%
            </span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default WeatherWidget;